const forms = (state = {}, data) => {
    if (data.action === 'SET_FORMS' && data.value) {
        return {
            ...data.value,
        }
    }
    return state
}

export default forms;